import { ReactNode } from "react";

import {
  Box,
  Heading,
  Inline,
  TypographyHeadingLevel,
  useForegroundVariantColor
} from "@seneca/senekit";

type Props = {
  children: ReactNode[];
  simple?: boolean;
  dividerSize?: [TypographyHeadingLevel, TypographyHeadingLevel];
};

export default function TimerLayout({
  children,
  simple = false,
  dividerSize
}: Props) {
  const foregroundVariantColor = useForegroundVariantColor("3");

  return (
    <>
      {simple ? (
        joinJSXElements({ elements: children, simple, dividerSize })
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          backgroundColor={foregroundVariantColor}
          borderRadius="xxsmall"
          paddingX="large"
          paddingY="small"
        >
          {joinJSXElements({ elements: children, dividerSize })}
        </Box>
      )}
    </>
  );
}

function joinJSXElements({
  elements,
  simple = false,
  dividerSize = ["3", "4"]
}: {
  elements: Array<ReactNode>;
  dividerSize?: [TypographyHeadingLevel, TypographyHeadingLevel];
  simple?: boolean;
}) {
  return elements.length > 0
    ? elements
        .filter(n => n)
        .reduce((result, element) => (
          <Inline
            space="small"
            flexWrap="nowrap"
            justifyContent="center"
            alignItems="baseline"
          >
            {result}
            <Heading level={simple ? dividerSize[0] : dividerSize[1]}>
              :
            </Heading>
            {element}
          </Inline>
        ))
    : null;
}
